import { fetchApi } from '@/config/axiosSetting';
import {
  WalletPeriodSummaryQueryParamsType,
  WalletPeriodSummaryQueryResponseType,
} from './walletPeriodSummaryQuery.type';

export const walletPeriodSummaryFunction = (
  params: WalletPeriodSummaryQueryParamsType,
): Promise<WalletPeriodSummaryQueryResponseType> => {
  return fetchApi.get(
    `financial/periods/${params.year}/${params.month}/wallet/`,
  );
};
